import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (this.hasInputTarget) {
      this.resize()
    }
  }

  resize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = el.scrollHeight + "px"
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.closest("form")?.requestSubmit()
    }
  }
}
